(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wg-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wg-hero-slider')) {
    class WgHeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.wg-slide'));
        if (this.slides.length < 2) return;
        this.track = this.querySelector('.wg-slider__track');
        this.dots = Array.from(this.querySelectorAll('.wg-slider__dot'));
        this.toggleBtn = this.querySelector('.wg-slider__toggle');
        this.index = 0;
        this.interval = Math.max(3, parseFloat(this.dataset.interval) || 6) * 1000;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.userPaused = this.dataset.autoplay !== 'true' || reduced;
        this.hoverPaused = false;
        this.focusPaused = false;

        this.querySelector('.wg-slider__arrow--prev')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('.wg-slider__arrow--next')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));
        this.toggleBtn?.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.restart();
        });

        this.addEventListener('mouseenter', () => { this.hoverPaused = true; this.restart(); });
        this.addEventListener('mouseleave', () => { this.hoverPaused = false; this.restart(); });
        this.addEventListener('focusin', () => { this.focusPaused = true; this.restart(); });
        this.addEventListener('focusout', (e) => {
          if (!this.contains(e.relatedTarget)) { this.focusPaused = false; this.restart(); }
        });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1, true); }
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1, true); }
        });

        this.track.addEventListener('touchstart', (e) => {
          const t = e.touches[0];
          this.sx = t.clientX; this.sy = t.clientY;
          this.hoverPaused = true; this.restart();
        }, { passive: true });
        this.track.addEventListener('touchend', (e) => {
          const t = e.changedTouches[0];
          const dx = t.clientX - this.sx;
          const dy = t.clientY - this.sy;
          this.hoverPaused = false;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
            this.go(this.index + (dx < 0 ? 1 : -1), true);
          } else {
            this.restart();
          }
        }, { passive: true });

        this.onVisibility = () => this.restart();
        document.addEventListener('visibilitychange', this.onVisibility);

        this.onBlockSelect = (e) => {
          const i = this.slides.findIndex((s) => s.contains(e.target) || s === e.target);
          if (i >= 0) { this.userPaused = true; this.go(i, true); }
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.restart();
      }

      disconnectedCallback() {
        this.stop();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      go(i, fromUser) {
        const n = this.slides.length;
        const next = ((i % n) + n) % n;
        if (next !== this.index) {
          this.slides.forEach((slide, k) => {
            const active = k === next;
            slide.classList.toggle('is-active', active);
            if (active) {
              slide.removeAttribute('aria-hidden');
              slide.inert = false;
            } else {
              slide.setAttribute('aria-hidden', 'true');
              slide.inert = true;
            }
          });
          this.dots.forEach((dot, k) => {
            if (k === next) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
          this.dataset.tone = this.slides[next].dataset.tone || 'dark';
          this.index = next;
          const upcoming = this.slides[(next + 1) % n].querySelector('img');
          if (upcoming) upcoming.loading = 'eager';
        }
        if (fromUser) this.restart();
      }

      stop() {
        if (this.timer) { clearInterval(this.timer); this.timer = null; }
      }

      restart() {
        this.stop();
        const playing = !this.userPaused && !this.hoverPaused && !this.focusPaused && !document.hidden;
        if (playing) this.timer = setInterval(() => this.go(this.index + 1, false), this.interval);
        this.track.setAttribute('aria-live', this.userPaused ? 'polite' : 'off');
        this.classList.toggle('is-paused', this.userPaused);
        if (this.toggleBtn) {
          this.toggleBtn.setAttribute('aria-label', this.userPaused ? this.toggleBtn.dataset.labelPlay : this.toggleBtn.dataset.labelPause);
        }
      }
    }
    customElements.define('wg-hero-slider', WgHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wg-promo-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wg-promo-slider')) {
    class WgPromoSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.wg-promo__track');
        this.dotsWrap = this.querySelector('.wg-promo__dots');
        this.toggleBtn = this.querySelector('.wg-promo__toggle');
        this.interval = Math.max(3, parseFloat(this.dataset.interval) || 5) * 1000;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.userPaused = this.dataset.autoplay !== 'true' || reduced;
        this.hoverPaused = false;
        this.focusPaused = false;

        // Weekly rotation safety net: if the HTML came from a cache of a previous week, swap to this week's set.
        const sets = (this.dataset.sets || '').split(',').filter(Boolean).map(Number);
        const forced = Number(this.dataset.forced) || 0;
        const designMode = !!(window.Shopify && window.Shopify.designMode);
        if (sets.length && !forced && !designMode) {
          const week = Math.floor((Date.now() / 1000 + 241200) / 604800);
          const want = sets[(((week + (Number(this.dataset.offset) || 0)) % sets.length) + sets.length) % sets.length];
          if (want !== Number(this.dataset.current)) this.showSet(want);
        }

        this.setup();

        this.querySelector('.wg-promo__arrow--prev').addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('.wg-promo__arrow--next').addEventListener('click', () => this.go(this.index + 1, true));
        this.toggleBtn?.addEventListener('click', () => { this.userPaused = !this.userPaused; this.restart(); });
        this.addEventListener('mouseenter', () => { this.hoverPaused = true; this.restart(); });
        this.addEventListener('mouseleave', () => { this.hoverPaused = false; this.restart(); });
        this.addEventListener('focusin', () => { this.focusPaused = true; this.restart(); });
        this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) { this.focusPaused = false; this.restart(); } });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1, true); }
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1, true); }
        });

        // Touch swipe with the track following the finger.
        const vp = this.querySelector('.wg-promo__viewport');
        vp.addEventListener('touchstart', (e) => {
          const t = e.touches[0];
          this.sx = t.clientX; this.sy = t.clientY; this.dx = 0; this.dragging = null;
          this.hoverPaused = true; this.restart();
        }, { passive: true });
        vp.addEventListener('touchmove', (e) => {
          const t = e.touches[0];
          const dx = t.clientX - this.sx, dy = t.clientY - this.sy;
          if (this.dragging === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) this.dragging = Math.abs(dx) > Math.abs(dy);
          if (this.dragging) {
            this.dx = dx;
            this.track.style.transition = 'none';
            this.track.style.transform = `translate3d(calc(${-this.index * 100}% + ${dx}px),0,0)`;
          }
        }, { passive: true });
        vp.addEventListener('touchend', () => {
          this.track.style.transition = '';
          this.hoverPaused = false;
          const w = vp.clientWidth || 1;
          if (this.dragging && Math.abs(this.dx) > Math.min(60, w * 0.15)) {
            this.suppressClick = true; setTimeout(() => (this.suppressClick = false), 350);
            this.go(this.index + (this.dx < 0 ? 1 : -1), true);
          } else { this.go(this.index, true, true); }
          this.dragging = null;
        }, { passive: true });
        this.track.addEventListener('click', (e) => { if (this.suppressClick) e.preventDefault(); });

        this.onVisibility = () => this.restart();
        document.addEventListener('visibilitychange', this.onVisibility);
        this.onBlockSelect = (e) => {
          const set = Number(e.target?.dataset?.wgSet);
          if (!set || !this.contains(e.target) && !this.querySelector(`template[data-wg-set="${set}"]`)) return;
          if (set !== Number(this.dataset.current)) { this.showSet(set); this.setup(); }
          const i = this.slides.findIndex((s) => s.dataset.blockId === e.detail?.blockId);
          this.userPaused = true; this.go(Math.max(0, i), true, true);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        this.restart();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      showSet(set) {
        const tpl = this.querySelector(`template[data-wg-set="${set}"]`);
        if (!tpl) return;
        const cur = document.createElement('template');
        cur.dataset.wgSet = this.dataset.current;
        Array.from(this.track.children).forEach((c) => cur.content.appendChild(c));
        this.track.appendChild(tpl.content.cloneNode(true));
        tpl.replaceWith(cur);
        this.dataset.current = String(set);
      }

      setup() {
        this.slides = Array.from(this.track.querySelectorAll('.wg-promo__slide'));
        this.index = 0;
        this.dotsWrap.innerHTML = '';
        this.dots = this.slides.map((s, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'wg-promo__dot';
          b.setAttribute('aria-label', `Ir a la promoción ${i + 1} de ${this.slides.length}: ${s.dataset.label || ''}`);
          b.setAttribute('aria-controls', this.track.id);
          b.innerHTML = '<span></span>';
          b.addEventListener('click', () => this.go(i, true));
          this.dotsWrap.appendChild(b);
          return b;
        });
        this.classList.toggle('is-single', this.slides.length < 2);
        this.go(0, false, true);
      }

      go(i, fromUser, force) {
        const n = this.slides.length;
        if (!n) return;
        const next = ((i % n) + n) % n;
        if (next !== this.index || force) {
          this.slides.forEach((s, k) => {
            const on = k === next;
            s.classList.toggle('is-active', on);
            s.setAttribute('aria-label', `${k + 1} de ${n}: ${s.dataset.label || ''}`);
            if (on) { s.removeAttribute('aria-hidden'); s.inert = false; }
            else { s.setAttribute('aria-hidden', 'true'); s.inert = true; }
          });
          this.dots.forEach((d, k) => (k === next ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current')));
          this.index = next;
          this.track.style.transform = `translate3d(${-next * 100}%,0,0)`;
          [next, (next + 1) % n].forEach((k) => { const img = this.slides[k].querySelector('img'); if (img && this.seen) img.loading = 'eager'; });
        }
        if (fromUser) this.restart();
      }

      stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }

      restart() {
        this.stop();
        if (!this.io) {
          this.io = new IntersectionObserver((es) => { this.inView = es[0].isIntersecting; if (this.inView && !this.seen) { this.seen = true; this.go(this.index, false, true); } this.restart(); }, { threshold: 0.35 });
          this.io.observe(this);
        }
        const playing = this.inView && !this.userPaused && !this.hoverPaused && !this.focusPaused && !document.hidden && this.slides.length > 1;
        if (playing) this.timer = setInterval(() => this.go(this.index + 1, false), this.interval);
        this.track.setAttribute('aria-live', this.userPaused ? 'polite' : 'off');
        this.classList.toggle('is-paused', this.userPaused);
        if (this.toggleBtn) this.toggleBtn.setAttribute('aria-label', this.userPaused ? this.toggleBtn.dataset.labelPlay : this.toggleBtn.dataset.labelPause);
      }
    }
    customElements.define('wg-promo-slider', WgPromoSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
